import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUserName } from '../../selectors/index';
// import MenuItem from 'react-bootstrap/lib/MenuItem';
// import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { browserHistory } from 'react-router';
// import Modal from '../Enhanced/Modal';



class Header extends React.Component {
  logOut = () => {
    const modalLookup = window.osa && window.osa.commonLookup.modal;

    const modal = {
      headerText: modalLookup.warningOnLogOut.header,
      bodyText: modalLookup.warningOnLogOut.body,
      actionButtonText: "OK",//if noting assigned, it will not shown
      closeButtonText: "Cancel",//if noting assigned, it will not shown
      onActionClicked: () => {
        const p = this.props;
        p.dispatch({ type: 'LOG_OUT' });
        browserHistory.push('/logout');
      }
    };

    this.props.dispatch({ type: 'SHOW_MODAL', data: modal });
  };

  showLogoutWarningModal = () => {
    const modalLookup = window.osa && window.osa.commonLookup.modal;

    const modal = {
      headerText: modalLookup.navigateAway.header,
      bodyText: modalLookup.navigateAway.body,
      actionButtonText: "OK",//if noting assigned, it will not shown
      closeButtonText: "Cancel",//if noting assigned, it will not shown
      onActionClicked: () => { browserHistory.push('/login'); }
    };

    this.props.dispatch({ type: 'SHOW_MODAL', data: modal });

  };

  showModal = (location) => {
    const modalLookup = window.osa && window.osa.commonLookup.modal;

    const currentPage = this.props.location.pathname;
    if (currentPage == "/" || currentPage.indexOf("profile") > -1
      || currentPage.indexOf("register") > -1 || currentPage.indexOf("newgasline") > -1
      || currentPage.indexOf("serviceremoval") > -1) {
      const data = {
        headerText: modalLookup.navigateAway.header,
        bodyText: modalLookup.navigateAway.body,
        actionButtonText: "OK",//if noting assigned, it will not shown
        closeButtonText: "Cancel",//if noting assigned, it will not shown
        onActionClicked: () => { browserHistory.push(location); }
      };

      this.props.dispatch({ type: 'SHOW_MODAL', data: data });
    }
    else {
      browserHistory.push(location);
    }
  };

  render() {
    const p = this.props;
    // const siteUrl = window.osa && window.osa.siteUrl;

    return (
      <table className="" id="WebCalcHeader" cellSpacing="0" cellPadding="0" width="100%">
        <tbody><tr style={{ borderStyle: "none" }}>
          <td style={{ padding: "0px", borderStyle: "none", verticalAlign: "middle" }}>
            <div id="header1">
              <div id="header_center">
                <header className="header">
                  <div className="container-fluid container-flex desktop-header">
                    <div className="header--logo">
                      <a className="svg" href="/"><img src="../../images/FBC-289-55.png" /></a>
                    </div>
                    <div className="header--aside">
                      <div className="header--nav_tertiary">
                        <div id="nav_tertiary">


                        </div>
                        <div className="header--search">
                          {p.isLoggedIn ?
                            <div className="row nav-row" >
                              <div className="header-username">
                                <label> {p.getUserName}</label> &nbsp;&nbsp;&nbsp;&nbsp;
                                <a className="action-link" onClick={this.logOut} >
                                  <i className="fa fa-sign-out" aria-hidden="true" /> Log out</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a className="action-link" onClick={() => this.showModal('/profile')} ><i className="fa fa-user" aria-hidden="true" /> My profile</a>
                                &nbsp;&nbsp;
                                <a className="action-link" onClick={() => this.showModal('/dashboard')} ><i className="fa fa-user" aria-hidden="true" /> My requests</a>
                              </div>
                            </div>
                            :
                            <div className="row nav-row" >
                              <div className="header-login">
                                <i className="fa fa-angle-double-right" aria-hidden="true" />&nbsp;
                                <a className="action-link" onClick={() => this.showModal('/login')} >Service request login</a>
                              </div>
                            </div>
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </td>

        </tr>
          <tr style={{ borderStyle: "none", verticalAlign: "bottom" }}>
            <td colSpan="2">
              <table className="TopLine" id="WebCalcHeader" cellSpacing="0" cellPadding="3" width="100%">
              </table>
            </td>
          </tr>

        </tbody>
      </table>
    );
  }
}

Header.propTypes = {
  isLoggedIn: PropTypes.bool,
  getUserName: PropTypes.string,
  logOut: PropTypes.func,
  dispatch: PropTypes.func,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    isLoggedIn: state.gas.user && state.gas.user.isAuthenticated,
    getUserName: getUserName(state),
  };
}

export default connect(mapStateToProps)(Header);